import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { CaseService } from '../../services/case.service';
import { DictionaryService } from '../../services/dictionary.service';
import { UtilitiesService } from '../../services/utilities.service';
import { ApplicationApplicantDto } from './dto/application-applicant.dto';
import { MessageService, Message } from 'primeng/api';
import { CookieService } from 'ngx-cookie-service';

import { IApplicant } from 'src/app/shared/classes/applicant';

@Component({
  selector: 'app-case-applicant',
  templateUrl: './case-applicant.component.html'
})
export class CaseApplicantComponent implements OnInit {

  @Input() caseId: string;
  @Input() applicantType: string;
  @Output() changeEvent = new EventEmitter();
  applicant: any; // ApplicationApplicantDto;
  applicantList: IApplicant[];  // list of "generic" Applicants
  cols: any[];
  applicantTypeList: [];
  bHasPrevApplicant = false;

  constructor(private caseService: CaseService, private dictService: DictionaryService, private utilService: UtilitiesService,
              private messageService: MessageService, private cookieService: CookieService) { }

  ngOnInit() {
    this.applicant = new ApplicationApplicantDto().create();
    const dicts = this.dictService.getDictionaries(); // get all dictionaries
    this.applicantTypeList = dicts.applicantTypes;
    this.applicantList = [];  // initialize applicant list (populated when doing searches)
    this.cols = [
      { field: 'id'},
      { field: 'name', header: 'Name' },
      { field: 'strAddr', header: 'Street Addr' },
      { field: 'city', header: 'City' },
      { field: 'state', header: 'State' },
      { field: 'phone', header: 'Phone' },
      { field: 'email', header: 'Email' }
  ];

    if (!this.caseId) { // it's a new case...
      this.bHasPrevApplicant = this.checkPrevApplicant();
      this.dataChange();
      return;
    }
    this.caseService.getCaseApplicant(this.caseId).subscribe(data => {
      this.utilService.doAudit(data, 'applicant for caseId: ' + this.caseId + '; type: ' + this.applicantType);
      this.applicant = data;
      this.applicant.type = this.applicantType; // include Applicant Type in IApplicant for ease of transmission to Parent component
      this.dataChange();  // force an emit event, so the parent component can capture Applicant data
    });

  }

  // this method executed whenever any data in the component is changed; it should trigger an event defined on the PARENT component
  dataChange() {
    this.utilService.doAudit(this.applicant, 'applicant data changed');
    this.changeEvent.emit(this.applicant);
  }

  getLastApplicant(): void {
    const userName = this.cookieService.get('userName');

    const obj = localStorage.getItem(userName + '-lastApplicant');
    this.utilService.doAudit(obj, 'stringified applicant obj:');
    if (obj) {
      this.applicant = JSON.parse(obj);
      this.dataChange();  // emit the change
    }
  }
  getApplicantList() {
    this.applicantList = [];
    let xString = this.applicant.name;
    xString = xString.replace(/[|&;$%@"<>()+.]/g, '');
    this.caseService.findApplicant(xString).subscribe(data => {
      if (data) {
        this.applicantList = data;
        if (data.length < 1) {
          this.showToast({ key: 'toast', severity: 'info', detail: 'No matching Applicant found!', summary: 'Info' });
        }
      }
      return;
    });
  }

  applicantSelected(item) {
    this.applicant.name = item.name;
    this.applicant.strAddr = item.strAddr;
    this.applicant.email = item.email;
    this.applicant.city = item.city;
    this.applicant.state = item.state;
    this.applicant.zip = item.zip;
    this.applicant.phone = item.phone;
    this.applicant.id = item.id;
    this.applicantList = [];  // this should hide the applicant list div!
    this.dataChange();  // emit event for data change!
    return;
  }
  clearApplicantList() {
    this.applicantList = [];
  }

  // Toaster/Message-related methods
  showToast(msg: Message) {
    this.messageService.clear('toast');
    this.messageService.add(msg);
  }

  showInfo(myMsg: Message) {
    this.messageService.clear('info');
    this.messageService.add(myMsg);
  }

  clearAll() {
    this.messageService.clear();
  }

  checkPrevApplicant(): boolean {
    const userName = this.cookieService.get('userName');
    const obj = localStorage.getItem(userName + '-lastApplicant');
    if (obj) {
      return true;
    } else {
      return false;
    }
  }

}
